import styled from "styled-components";

export const Container = styled.div``;
export const RadioLabel = styled.span`
  font-size: 10px;
  text-transform: uppercase;
`;
